

  <section class="container-fluid">
    <div class="col-12  d-flex justify-content-between">
        <h2 class="text-left text-white px-5 my-4">Listado de pagos de: {{project}}</h2>
        <div class="d-flex justify-content-center align-items-center">
            <button
            class="badge rounded-pill btn btn-outline-light mx-2"
            [routerLink]="['/pdg/finance/hes/1']"
            
          >
            <i class="fa-solid fa-right-from-bracket m-2 fs-6" aria-hidden="true"></i>
            <span class="m-2 fs-6">Volver al listado. </span>
            
          </button>
         
        </div>
    </div>
</section>
<section class="container-fluid">
   

  
  <div class="col-12 text-end">
  
    <br>
  </div>

    <div class="container-fluid px-5">
      <div class="backgroundTable">
  
      
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes">
          
          <ng-container *ngIf="ListPay.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="ListPay.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">HER</th>
              <th class="text-white text-center">Factura</th>
              <th class="text-white text-center">Hito</th>
              <th class="text-white text-center">Proyecto</th>
              
              
              <th class="text-white text-center">Moneda</th>
              <th class="text-white text-center">Monto</th>
              <th class="text-white text-center">%</th>
              <th class="text-white text-center">Estado</th>
              <th class="text-white text-center">Opciones</th>

          </thead>

          <tbody>
            <tr *ngFor="let pay of ListPay">
 
              <td class="text-center">{{pay.hes}}</td>
              <td class="text-center">{{pay.facture}}</td>
              <td class="text-center">{{pay.title}}</td>
              
              <td class="text-center">{{client}}</td>
              <td class="text-center">{{pay.money}}</td>
              <td class="text-center">{{pay.amount}}</td>
              <td class="text-center">{{pay.amount_percent}}</td>
              <td >
                <div class="p-2 bd-highlight d-flex flex-column">
                    <span *ngIf="pay.status === 'REPROGRAMADO'"
                      class="badge rounded-pill text-bg-programado p-2" style="font-size: 12px;">{{pay.status}}</span>
                    <span *ngIf="pay.status === 'PAGADO'"
                      class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">{{pay.status}}</span>
                    <span *ngIf="pay.status === 'ANULADO'"
                      class="badge rounded-pill text-bg-anulado p-2 " style="font-size: 12px;">{{pay.status}}</span>
                    <span *ngIf="pay.status === 'PENDIENTE'"
                      class="badge rounded-pill text-bg-pendiente p-2 " style="font-size: 12px;">{{pay.status}}</span>
                    <span *ngIf="pay.status === 'CREADO'"
                      class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">{{pay.status}}</span>
                </div>

            </td>

            

              <td *ngIf="pay.status == 'PAGADO'" class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['/pdg/finance/payEdit/', pay.id, id]" ngbDropdownItem>Editar</button>
               
                  </div>
                </div>
              </td>
              <td *ngIf="pay.status != 'PAGADO'" class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['/pdg/finance/pay/into', pay.id, id]" ngbDropdownItem>Pagar</button>
                    <button [routerLink]="['/pdg/finance/payEdit/', pay.id, id]" ngbDropdownItem>Editar</button>
                  </div>
                </div>
              </td>
              
             
              
           
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
  </section>
